'use strict';

export default class changePasswordController {

  /*@ngInject*/
  constructor(Auth, $state, $scope, $http, $location, $stateParams) {
    var vm = this;

    vm.patchPassword = function(){
      $http.post(`api/users/reset-password`, {password : vm.password, resetToken : $stateParams.token, email: $stateParams.email}).then(function (response) {
        console.log(response);
        if(response.data.error) {
          return vm.errors = response.data;
          $scope.$apply();
        }

        Auth.login({
          email: response.data,
          password: vm.password
        })
        .then(() => {
          $state.go('main');
        })
        .catch(err => {
          $location.path('/');
        });
      }).catch(function(response){
        vm.errors = response.data
        // $location.path('/');
      })
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/changePassword/changePassword.controller.js